export const Urls = {
    GetMepShorePowerActualEmissionsByPoi: "MepScenarioPlanning/GetMepShorePowerActualEmissionsByPoi",
    GetMepPortTrafficActualEmissionsByVesselType: "MepScenarioPlanning/GetMepPortTrafficActualEmissionsByVesselType"
  }